import { FC } from 'react';
import { ActionsByProductTypeProps } from './TypeProps';
import { ActionBlock } from '@entities/Actions';
import { useAppSelector } from '@redux/hooks';
import { getActionsByProduct } from '../../module/selectors/getActionsByProduct/getActionsByProduct';
import { getStatusLoading } from '../../module/selectors/getStatusLoading/getStatusLoading';
import { SkeletonLoading } from '@shared/ui/SkeletonLoading';
import classNames from 'classnames';
import IconLabel from './icons/label.svg';
import { ErrorBoundaryComponent } from '@app/shared/ui/ErrorBoundary';

import styles from './ActionsByProduct.module.scss';

export const ActionsByProduct: FC<ActionsByProductTypeProps> = ({ className }) => {
  const actions = useAppSelector(getActionsByProduct);
  const isLoading = useAppSelector(getStatusLoading);

  if (isLoading) {
    return (
      <div className={classNames(styles.WrapperActionsByProduct, { [styles.Visible]: true }, className)}>
        <SkeletonLoading width={'72px'} height={'21px'} />
        <SkeletonLoading width={'100%'} height={'56px'} />
        <SkeletonLoading width={'100%'} height={'56px'} />
        <SkeletonLoading width={'100%'} height={'56px'} />
      </div>
    );
  }

  return (
    <div className={classNames(styles.WrapperActionsByProduct, { [styles.Visible]: actions?.length > 0 }, className)}>
      <ErrorBoundaryComponent>
        <IconLabel width={72} height={21} />
        {actions?.map(item => <ActionBlock key={item.name} {...item} />)}
      </ErrorBoundaryComponent>
    </div>
  );
};
